import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import capitalize from 'lodash/capitalize'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { Folders as FoldersType } from 'modules/documents/store/collections/folders'

import Item from './Item'

interface Props {
  folders: FoldersType
}

const Folders = ({ folders }: Props) => (
  <Table>
    <Table.Head>
      <Table.Row>
        <Table.HeadCell>{capitalize(i18n.t('common.name'))}</Table.HeadCell>
        <Table.HeadCell>{capitalize(i18n.t('common.directory'))}</Table.HeadCell>
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {folders.map((folder) => (
        <Item key={folder.attributes.id} folder={folder} />
      ))}
    </Table.Body>
  </Table>
)

export default observer(Folders)
